import { render } from "./profileDetail.vue?vue&type=template&id=611056c6&ts=true"
import script from "./profileDetail.vue?vue&type=script&lang=ts"
export * from "./profileDetail.vue?vue&type=script&lang=ts"

import "./profileDetail.vue?vue&type=style&index=0&id=611056c6&lang=css"

import exportComponent from "/home/devadm/tuyensinh-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__